import {Dispatch} from "redux";
import {IResponse, RACARequest} from "../../Request";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";

export default async function uploadSignUpFileRequest(
  dispatch: Dispatch,
  userId: string,
  file: File,
  type: string,
  group: string,
): Promise<IResponse> {
  dispatch(startLoading());

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  formData.append('group', group);

  const request = new RACARequest('auth', 'signupTalentFormFile')
    .setPathValues('ID', userId)
    .useFormData()
    .setData(formData);

  const response = await request.makeRequest();

  dispatch(endLoading());

  return response;
}
